import Vue from "vue";
import ImageUploader from "@/components/ImageUploader";
import FileUploader from "@/components/FileUploader";
import MultipleFileUploader from "@/components/MultipleFileUploader";

Vue.use(ImageUploader);
Vue.use(FileUploader);
Vue.use(MultipleFileUploader);
